export const environment = {
  production: false,
  // apiCervinoBackend: "http://208.109.247.40:9090/"
  apiCervinoBackend: "https://ec2demo.altos-apps.com/"
};